import React, { useState, useEffect, useCallback } from "react";
import "./DualRangeSlider.scss";

export function DualRangeSlider({ setQueryParams }) {
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(10000);
  const [leftPercent, setLeftPercent] = useState(0);
  const [rightPercent, setRightPercent] = useState(0);
  const [debounceTimer, setDebounceTimer] = useState(null);

  useEffect(() => {
    const left = (minValue / 10000) * 100;
    const right = 100 - (maxValue / 10000) * 100;
    setLeftPercent(left);
    setRightPercent(right);
  }, [minValue, maxValue]);

  // Debounced function to update query params
  const debouncedSetQueryParams = useCallback((min, max) => {
    // Clear existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    // Set new timer
    const newTimer = setTimeout(() => {
      setQueryParams(prev => ({
        ...prev,
        price: [min, max],
        page: 1 // Always reset to page 1 when price changes
      }));
    }, 500); // 500ms delay
    
    setDebounceTimer(newTimer);
  }, [debounceTimer, setQueryParams]);

  const handleMinChange = (e) => {
    const value = parseInt(e.target.value);
    if (value <= maxValue) {
      setMinValue(value);
      // Call debounced function instead of immediate setQueryParams
      debouncedSetQueryParams(value, maxValue);
    }
  };

  const handleMaxChange = (e) => {
    const value = parseInt(e.target.value);
    if (value >= minValue) {
      setMaxValue(value);
      // Call debounced function instead of immediate setQueryParams
      debouncedSetQueryParams(minValue, value);
    }
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  return (
    <div className="dual-range-wrapper">
      <div className="input-fields">
        <div className="field">
          <span>Min</span>
          <input
            type="number"
            value={minValue}
            onChange={handleMinChange}
            min="0"
            max="10000"
          />
        </div>
        <div className="field">
          <span>Max</span>
          <input
            type="number"
            value={maxValue}
            onChange={handleMaxChange}
            min="0"
            max="10000"
          />
        </div>
      </div>

      <div className="slider-container">
        <div className="slider-track">
          <div 
            className="slider-progress" 
            style={{ left: `${leftPercent}%`, right: `${rightPercent}%` }}
          ></div>
        </div>
        <div className="slider-inputs">
          <input
            type="range"
            min="0"
            max="10000"
            value={minValue}
            onChange={handleMinChange}
            className="range-min"
          />
          <input
            type="range"
            min="0"
            max="10000"
            value={maxValue}
            onChange={handleMaxChange}
            className="range-max"
          />
        </div>
      </div>

      <div className="search-button">
        <span>Search</span>
      </div>
    </div>
  );
} 